import React from "react";
import { Skeleton } from "@material-ui/lab";
import "!style-loader!css-loader!../styles.css";

const VerifyLoadingPage = () => (
  <div className="verify-loading-page">
    <Skeleton animation="wave" height={24} width={254} className="mb-4" />
    <Skeleton animation="wave" height={24} width={254} className="mb-2" />
    <Skeleton animation="wave" height={48} width={426} className="mb-4" />
    <Skeleton
      animation="wave"
      height={16}
      width={61}
      style={{ marginBottom: "6px" }}
    />
    <Skeleton animation="wave" height={32} width={426} className="mb-4" />
    <Skeleton
      animation="wave"
      height={16}
      width={115}
      style={{ marginBottom: "6px" }}
    />
    <Skeleton animation="wave" height={32} width={426} className="mb-4" />
    <Skeleton animation="wave" height={32} width={426} className="mb-4" />
  </div>
);

export default VerifyLoadingPage;
